import { createAppTheme } from './createAppTheme';
import { ADMIN_PRESET, PORTAL_PRESET } from './presets';

export const adminTheme = createAppTheme(ADMIN_PRESET);
export const portalTheme = createAppTheme(PORTAL_PRESET);
